import { Injectable, signal } from '@angular/core';
import { modalPath } from "../configs/listing-files-modal-config";

@Injectable({
  providedIn: 'root'
})
export class ListingPathStateService {
  private _pathState = signal<string>('');
  public pathState = this._pathState.asReadonly();

  public setPathState(modalKey: string): void {
    this._pathState.set(modalPath[modalKey]);
  }

  public resetPathState(): void {
    this._pathState.set('');
  }
}
